import React from 'react'

import { Box, Flex, styled, Text } from '@driftt/dds'

const DividerContainer = styled(Flex, {
  '& p': {
    margin: '0px!important', // override setup-container-fields global styles
    color: '$gray8!important', // override setup-container-fields global styles
  },
})

const DividerLine = styled(Box, {
  height: '2px',
  backgroundColor: '$gray3',
  width: '150px',
})

const DivderText = styled(Text, {
  textAlign: 'center',
  width: '100%',
  margin: 0,
})

export const ThirdPartySignUpDivider = () => (
  <DividerContainer direction="row" fullWidth alignItems="center">
    <DividerLine />
    <DivderText>
      or automatically set up your name, photo and calendar by signing in with:
    </DivderText>
    <DividerLine />
  </DividerContainer>
)
